
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Action, Getter } from 's-vuex-class'
import { SuggestionAction, SuggestionView } from '@/entities/suggestions'
import Button from '@/components/WebView/Button.vue'
import AvatarOrInitials from '@/components/WebView/AvatarOrInitials.vue'
import ActionLabel from './ActionLabel.vue'
import SuggestionAgreedUsersModal from './SuggestionAgreedUsersModal.vue'
import { ComponentMounter } from '@/utils/component-mounter'
import { UserColors } from '@/utils/userColors'

@Component<SuggestionAgreement>({
    components: { Button, ActionLabel, AvatarOrInitials },
})
export default class SuggestionAgreement extends Vue {
    @Prop(Object) public suggestion!: SuggestionView
    @Prop({ type: String, default: '' }) public action!: SuggestionAction

    @Getter private getUserId
    @Action public createSuggestionVote!: (suggestionId: number) => void
    @Action public removeSuggestionVote!: (suggestionId: number) => void

    public get colors() {
        return UserColors
    }

    public get displayUsersMax(): number {
        return 3
    }

    public get usersAgreed() {
        return this.suggestion.users_agreed
    }

    public get hasAgreed(): boolean {
        return !!this.usersAgreed.find(
            (u) => u.id.toString() === this.getUserId.toString()
        )
    }

    public get firstAgreed() {
        return this.usersAgreed.slice(0, this.displayUsersMax)
    }

    public get othersAgreed(): number {
        return this.usersAgreed.length - this.displayUsersMax
    }

    public async agree() {
        if (this.hasAgreed) {
            return // agreed already
        }

        await this.createSuggestionVote(this.suggestion.id)
    }

    public tapAgreedUsers() {
        const container = this.$refs.container as Element
        const propsData = { usersAgreed: this.usersAgreed }
        const modalInstance = ComponentMounter.mount(
            SuggestionAgreedUsersModal,
            container,
            propsData,
            this.$store
        )

        modalInstance.$once('close', () => {
            modalInstance.$destroy()
        })
    }

    public async removeAgreed() {
        if (!this.hasAgreed) {
            return // disagreed already
        }

        await this.removeSuggestionVote(this.suggestion.id)
    }
}
